import React, { useState, useContext } from "react";
import { Offcanvas, Form, Spinner, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../starek.css";
import classNames from "classnames";
// import { savePart, deletePart } from "../../services/RepositoryService";
import { useNavigate } from "react-router";
import { gql, useMutation } from "@apollo/client";
import StarekContext from "../../context/StarekContext";

function AddPartOffCanvasWizard(props) {
    const CREATE_ONE_PART_MUTATION = gql`
        mutation CreateOnePart($data: PartCreateInput!) {
            createOnePart(data: $data) {
                name
                description
                created_at
                created_by {
                    name
                }
                updated_by {
                    name
                }
            }
        }
    `;

    const UPDATE_ONE_PART_MUTATION = gql`
        mutation UpdateOnePart(
            $data: PartUpdateInput!
            $where: PartWhereUniqueInput!
        ) {
            updateOnePart(data: $data, where: $where) {
                name
                description
                updated_at
                updated_by {
                    name
                }
            }
        }
    `;

    const DELETE_ONE_PART_MUTATION = gql`
        mutation DeleteOnePart($where: PartWhereUniqueInput!) {
            deleteOnePart(where: $where) {
                id
                deleted_at
            }
        }
    `;

    const navigator = useNavigate();
    const starekContext = useContext(StarekContext);

    const [
        savePart,
        { data: partSaveData, loading: partSaving, error: partSaveError },
    ] = useMutation(CREATE_ONE_PART_MUTATION);
    const [
        updatePart,
        { data: partUpdateData, loading: partUpdating, error: partUpdateError },
    ] = useMutation(UPDATE_ONE_PART_MUTATION);
    const [
        deletePart,
        { data: partDeleteData, loading: partDeleting, error: partDeleteError },
    ] = useMutation(DELETE_ONE_PART_MUTATION);

    const handleSave = async (event) => {
        try {
            event.preventDefault();
            const formData = new FormData(event.target);
            const formValues = {};
            await savePart({
                variables: {
                    data: {
                        plant: {
                            connect: {
                                id: props.starekContext.lastUsedPlant.id,
                            },
                        },
                        name: formData.get("part_name"),
                        description: formData.get("part_description"),
                        created_by: {
                            connect: { id: parseInt(starekContext.user.id) },
                        },
                        updated_by: {
                            connect: { id: parseInt(starekContext.user.id) },
                        },
                    },
                },
            });
            props.closeOffcanvas(true, null);
        } catch (error) {
            starekContext.showError(error);
        }
    };
    const handleUpdate = async (event) => {
        try {
            event.preventDefault();
            const formData = new FormData(event.target);
            const formValues = {};
            await updatePart({
                variables: {
                    data: {
                        name: { set: formData.get("part_name") },
                        description: { set: formData.get("part_description") },
                        updated_at: { set: "2025-09-25T22:47:50.065Z" },
                        updated_by: {
                            connect: { id: parseInt(starekContext.user.id) },
                        },
                    },
                    where: {
                        id: props.item.id,
                    },
                },
            });
            props.closeOffcanvas(true, null);
        } catch (error) {
            starekContext.showError(error);
        }
    };
    const handleDelete = async () => {
        try {
            await deletePart({
                variables: {
                    where: {
                        id: props.item.id,
                    },
                },
            });
            props.closeOffcanvas(true, null);
        } catch (error) {
            props.starekContext.showError(error);
        }
    };

    const handleDiscard = () => {
        props.closeOffcanvas(true, null);
    };

    return (
        <>
            <Offcanvas
                show={props.show}
                onHide={props.handleClose}
                placement="end"
            >
                <Offcanvas.Header className="border-bottom" closeButton>
                    <Offcanvas.Title>
                        {props.item ? "Edit Part" : "Add a Part"}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="d-flex flex-column">
                    <Form
                        className="mt-4 font-weight-normal d-flex flex-column flex-grow-1"
                        onSubmit={props.item ? handleUpdate : handleSave}
                    >
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="border-4px-dotted-e6e6e6 rounded-circle p-5 bg-color-f2f2f2 position-relative">
                                <i className="fa fa-image fa-4x"></i>
                                <Button
                                    variant="primary"
                                    className="rounded-circle position-absolute bottom-0px"
                                >
                                    <i className="fa fa-pen text-light"></i>
                                </Button>
                            </div>
                        </div>
                        <Form.Group className="mb-3" controlId="part_name">
                            <Form.Label>
                                Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter here"
                                name="part_name"
                                defaultValue={props.item ? props.item.name : ""}
                            />
                        </Form.Group>
                        <Form.Group
                            className="mb-3"
                            controlId="part_description"
                        >
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Max allowed characters: 120"
                                name="part_description"
                                defaultValue={
                                    props.item ? props.item.description : ""
                                }
                            />
                        </Form.Group>
                        <div
                            className={classNames(
                                "d-flex align-items-center border-top pt-2 mt-auto",
                                {
                                    "justify-content-between": props.item?.id,
                                    "justify-content-end": !props.item,
                                }
                            )}
                        >
                            {props.item?.id && (
                                <Button
                                    variant="danger"
                                    onClick={handleDelete}
                                    disabled={partDeleting}
                                >
                                    {partDeleting && (
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    )}
                                    {partDeleting ? "Deleting..." : "Delete"}
                                </Button>
                            )}
                            <div>
                                <Button
                                    variant="outline-danger"
                                    id="cancel"
                                    onClick={handleDiscard}
                                >
                                    Discard
                                </Button>
                                <Button
                                    className="ms-2"
                                    variant="primary"
                                    id="part_submit"
                                    type="submit"
                                    disabled={partSaving || partUpdating}
                                >
                                    {(partSaving || partUpdating) && (
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    )}
                                    {props.item ? "Update" : "Save"}
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

export default AddPartOffCanvasWizard;
